import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import "../Electrician/Electrician.css"
const Plumber = ({ cart, addToCart }) => {
  const navigate = useNavigate();
  const [openService, setOpenService] = useState(null);
  const services = [
    {
      id: 201,
      title: "Tap Leakage Repair",
      price: 99,
      subtitle: "Fix tap dripping & leakage",
      extra_detail_1: "Stop tap dripping and water leakage",
      extra_detail_2: "Ensure smooth water flow operation",
      image: "https://www.h2pro.com.au/wp-content/uploads/2017/08/cause-of-leaking-tap.jpg"
    },
    {
      id: 202,
      title: "Tap accessory installation",
      price: 79,
      subtitle: "Fix water leakage in bathroom areas",
      extra_detail_1: "Install tap accessories securely",
      extra_detail_2: "Ensure proper fitting without leakage",
      image: "https://upload.wikimedia.org/wikipedia/commons/7/73/Wasserhahn.jpg"
    },
    {
      id: 203,
      title: "Tap installation/replacement",
      price: 99,
      subtitle: "Fix under-sink pipe leak",
      extra_detail_1: "Install or replace tap safely",
      extra_detail_2: "Ensure proper water flow connection",
      image: "https://upload.wikimedia.org/wikipedia/commons/7/73/Wasserhahn.jpg"
    },
    {
      id: 204,
      title: "Wash Basin Installation",
      price: 499,
      subtitle: "Secure & neat installation",
      extra_detail_1: "Install wash basin neatly and securely",
      extra_detail_2: "Ensure stable fitting and drainage",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0CzvYlkzv8gOjUvClz8KANrivNEu9ScgueA&s"
    },
    {
      id: 205,
      title: "Tap Installation",
      price: 149,
      subtitle: "Install new tap safely",
      extra_detail_1: "Install new tap with proper fitting",
      extra_detail_2: "Ensure leak free water connection",
      image: "https://upload.wikimedia.org/wikipedia/commons/7/73/Wasserhahn.jpg"
    },
    {
      id: 206,
      title: "Hand Shower Installation",
      price: 249,
      subtitle: "Shower fitting & setup",
      extra_detail_1: "Install hand shower with proper setup",
      extra_detail_2: "Ensure smooth water flow connection",
      image: "https://www.zapbathfittings.com/cdn/shop/products/TS402-1.jpg?v=1647335071&width=1214"
    },
    {
      id: 207,
      title: "Wash Basin Block Removal",
      price: 199,
      subtitle: "Clear clogged basin",
      extra_detail_1: "Remove blockage from wash basin drain",
      extra_detail_2: "Restore smooth water drainage flow",
      image: "https://images.ctfassets.net/0gqf8nju6pz6/40MWflrYn1Q6Y8f3zIcPlF/f13b8a7d7f42cb041ac29dad44139a83/image3.jpg"
    },
    {
      id: 208,
      title: "Bathroom Drain Block Removal",
      price: 249,
      subtitle: "Fix clogged bathroom drain",
      extra_detail_1: "Clear bathroom drain blockage quickly",
      extra_detail_2: "Ensure smooth water drainage flow",
      image: "https://www.turnerhastings.com.au/images/easyblog_articles/31/IMG_4776-2.jpg"
    },
    {
      id: 209,
      title: "Kitchen Drain Block Removal",
      price: 299,
      subtitle: "Clear kitchen pipeline clog",
      extra_detail_1: "Remove kitchen drain pipeline blockage",
      extra_detail_2: "Restore smooth water flow system",
      image: "https://www.cashandcarrykitchens.ie/images/made/images/uploads/inner/Runske_Kitchen_-_Augusta_Graphite_980x693_10_980_693_80_c1.jpg"
    },
    {
      id: 210,
      title: "Pipe Repair",
      price: 299,
      subtitle: "Fix broken or damaged pipes",
      extra_detail_1: "Repair damaged or leaking water pipes",
      extra_detail_2: "Ensure strong and secure connections",
      image: "https://www.cashandcarrykitchens.ie/images/made/images/uploads/inner/Runske_Kitchen_-_Augusta_Graphite_980x693_10_980_693_80_c1.jpg"
    },
    {
      id: 211,
      title: "Water Heater Installation",
      price: 499,
      subtitle: "Install new water heater",
      extra_detail_1: "Install water heater with secure fitting",
      extra_detail_2: "Ensure safe power and water connection",
      image: "https://www.ato.com/content/images/thumbs/0003609_2-kva-single-phase-automatic-voltage-stabilizer-for-home_550.jpeg"
    },
    {
      id: 212,
      title: "Bathroom Renovation Plumbing",
      price: 799,
      subtitle: "Complete bathroom plumbing setup",
      extra_detail_1: "Complete plumbing setup for bathroom",
      extra_detail_2: "Ensure proper water and drainage system",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRzhIR4fa_ZpRRlEVkDZWn27K4boHafUckuQ&s"
    },
    {
  id: 213,
  title: "Jet Spray Repair / Replacement",
  price: 99,
  subtitle: "Fix or replace jet spray",
  extra_detail_1: "Repair leakage or replace damaged spray",
  extra_detail_2: "Ensure smooth water flow",
  image: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7"
},
{
  id: 214,
  title: "Toilet Seat Cover Installation",
  price: 129,
  subtitle: "Install new toilet seat cover",
  extra_detail_1: "Proper fitting and alignment",
  extra_detail_2: "Ensure secure installation",
  image: "https://images.unsplash.com/photo-1604709177225-055f99402ea3"
},
{
  id: 215,
  title: "Flush Tank Repair",
  price: 149,
  subtitle: "Fix flush tank issues",
  extra_detail_1: "Repair leakage and flush problems",
  extra_detail_2: "Ensure proper water flow",
  image: "https://images.unsplash.com/photo-1620626011761-996317b8d101"
},
{
  id: 216,
  title: "External Flush Tank Replacement",
  price: 299,
  subtitle: "Replace flush tank",
  extra_detail_1: "Remove old tank and install new one",
  extra_detail_2: "Ensure leak-proof connection",
  image: "https://images.unsplash.com/photo-1584622781564-1d987f7333c1"
},
{
  id: 217,
  title: "Indian Toilet Repair / Installation",
  price: 399,
  subtitle: "Install or repair Indian toilet",
  extra_detail_1: "Fix cracks or install new unit",
  extra_detail_2: "Ensure proper drainage connection",
  image: "https://images.unsplash.com/photo-1598514982845-3f0d5a2b1c52"
},
{
  id: 218,
  title: "Western Toilet Repair (Wall-Mounted)",
  price: 249,
  subtitle: "Fix wall-mounted toilets",
  extra_detail_1: "Repair flushing or leakage issues",
  extra_detail_2: "Ensure proper alignment",
  image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a"
},
{
  id: 219,
  title: "Western Toilet Repair (Floor-Mounted)",
  price: 199,
  subtitle: "Fix floor-mounted toilets",
  extra_detail_1: "Repair leakage or flush problems",
  extra_detail_2: "Ensure stable fitting",
  image: "https://images.unsplash.com/photo-1598515214211-89d3c73ae83b"
},
{
  id: 220,
  title: "Shower Mixer Tap Installation",
  price: 199,
  subtitle: "Install mixer tap",
  extra_detail_1: "Hot and cold water connection setup",
  extra_detail_2: "Ensure leak-proof fitting",
  image: "https://images.unsplash.com/photo-1600566752355-35792bedcfea"
},
{
  id: 221,
  title: "Shower Filter Installation",
  price: 149,
  subtitle: "Install shower filter",
  extra_detail_1: "Improve water quality",
  extra_detail_2: "Easy installation with proper fitting",
  image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952"
},
{
  id: 222,
  title: "Shower Repair",
  price: 149,
  subtitle: "Fix shower issues",
  extra_detail_1: "Repair leakage or low pressure",
  extra_detail_2: "Ensure smooth water flow",
  image: "https://images.unsplash.com/photo-1621605815971-fbc98d665033"
},
{
  id: 223,
  title: "Soap Holder Installation",
  price: 99,
  subtitle: "Install soap holder",
  extra_detail_1: "Wall-mounted fitting",
  extra_detail_2: "Ensure secure placement",
  image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a"
},
{
  id: 224,
  title: "Towel Holder Installation",
  price: 99,
  subtitle: "Install towel holder",
  extra_detail_1: "Secure wall mounting",
  extra_detail_2: "Ensure durability",
  image: "https://images.unsplash.com/photo-1600566752227-8f2b2c07c7b5"
},
{
  id: 225,
  title: "Shelf Installation",
  price: 149,
  subtitle: "Install bathroom/kitchen shelf",
  extra_detail_1: "Proper alignment and drilling",
  extra_detail_2: "Strong and stable mounting",
  image: "https://images.unsplash.com/photo-1582582429416-9c3e1d5f6a9b"
},
{
  id: 226,
  title: "Wash Basin Leakage Repair",
  price: 149,
  subtitle: "Fix basin leakage",
  extra_detail_1: "Repair pipe or joint leaks",
  extra_detail_2: "Ensure smooth drainage",
  image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952"
},
{
  id: 227,
  title: "Waste Coupling Installation",
  price: 129,
  subtitle: "Install waste coupling",
  extra_detail_1: "Connect basin outlet properly",
  extra_detail_2: "Ensure leak-proof setup",
  image: "https://images.unsplash.com/photo-1598300188904-6287d52746d7"
},
{
  id: 228,
  title: "Drain Cover Installation",
  price: 99,
  subtitle: "Install drain cover",
  extra_detail_1: "Proper fitting over drainage",
  extra_detail_2: "Prevent clogging",
  image: "https://images.unsplash.com/photo-1600566752355-35792bedcfea"
},
{
  id: 229,
  title: "Connection Hose Installation",
  price: 99,
  subtitle: "Install water connection hose",
  extra_detail_1: "Secure inlet/outlet connection",
  extra_detail_2: "Prevent leakage",
  image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952"
},
{
  id: 230,
  title: "Washing Machine Inlet Installation",
  price: 149,
  subtitle: "Install washing machine inlet",
  extra_detail_1: "Connect water supply",
  extra_detail_2: "Ensure leak-free connection",
  image: "https://images.unsplash.com/photo-1626806819282-2c1dc01a6d9d"
},
{
  id: 231,
  title: "RO Water Connection Installation",
  price: 199,
  subtitle: "Install RO connection",
  extra_detail_1: "Connect water purifier inlet/outlet",
  extra_detail_2: "Ensure proper filtration flow",
  image: "https://images.unsplash.com/photo-1581093458791-9d09b7d3c6c0"
},
{
  id: 232,
  title: "Geyser Connection Leakage Repair",
  price: 199,
  subtitle: "Fix geyser leakage",
  extra_detail_1: "Repair pipe or valve leakage",
  extra_detail_2: "Ensure safe usage",
  image: "https://images.unsplash.com/photo-1600566752227-8f2b2c07c7b5"
},
{
  id: 233,
  title: "Shut-off Valve Leakage Repair",
  price: 129,
  subtitle: "Fix valve leakage",
  extra_detail_1: "Repair or replace faulty valve",
  extra_detail_2: "Ensure water control",
  image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952"
},
{
  id: 234,
  title: "Overhead Water Tank Installation",
  price: 999,
  subtitle: "Install water tank",
  extra_detail_1: "Proper placement and pipe connection",
  extra_detail_2: "Ensure strong base and support",
  image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc"
},
{
  id: 235,
  title: "Water Tank Repair",
  price: 499,
  subtitle: "Fix water tank issues",
  extra_detail_1: "Repair cracks or leakage",
  extra_detail_2: "Ensure durability",
  image: "https://images.unsplash.com/photo-1581091215367-59ab6b3c7c8b"
},
{
  id: 236,
  title: "Motor Installation",
  price: 499,
  subtitle: "Install water motor",
  extra_detail_1: "Proper wiring and pipe connection",
  extra_detail_2: "Ensure smooth functioning",
  image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc"
},
{
  id: 237,
  title: "Motor Air Cavity Removal",
  price: 149,
  subtitle: "Remove air lock in motor",
  extra_detail_1: "Fix air blockage issues",
  extra_detail_2: "Restore water flow",
  image: "https://images.unsplash.com/photo-1581091215367-59ab6b3c7c8b"
},
{
  id: 238,
  title: "Motor Air Cavity Removal",
  price: 149,
  subtitle: "Remove air lock in motor",
  extra_detail_1: "Fix air blockage issues",
  extra_detail_2: "Restore water flow",
  image: "https://images.unsplash.com/photo-1581091215367-59ab6b3c7c8b"
},
{
  id: 239,
  title: "Plumber Consultation",
  price: 99,
  subtitle: "Expert plumbing advice",
  extra_detail_1: "Inspection and issue diagnosis",
  extra_detail_2: "Get professional recommendations",
  image: "https://images.unsplash.com/photo-1581091012184-7c2f8f9c8c3f"
}
  ];
  return (
    <div className='container-fluid service-electrician'>
      <div id="Electronic">
        <h1>PLUMBER</h1>
      </div>
      <div className='elect-container'>
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}
                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Plumber